import {useNavigate, useParams} from "react-router-dom";
import {useEffect} from "react";
import { useTranslation } from 'react-i18next';
import jwt_decode from "jwt-decode";

const CaeAccess = () => {
    const { t } = useTranslation('common');
    const {aaffNif ,propertyNif, token} = useParams();
    const navigate = useNavigate();
    useEffect(() => {
        if (token) {
            const decoded = jwt_decode(token);
            const rol = decoded?.rol;
            let url;
            switch (rol) {
                case "ADMIN":
                case "TECH":
                case "SUPP":
                case "COMM":
                case "CONSUL":
                case "VENT":
                    url = `/aaff/${aaffNif}/comunidades/${propertyNif}`;
                    break;
                case "AAFF":
                    url = `/comunidades/${propertyNif}`;
                    break;
                default:
                    return;
            }
            localStorage.setItem("token", token);
            navigate(url, {replace: true});
        }
    }, [aaffNif, propertyNif, token, navigate]);
    return <div>{t('status.loading')}</div>
};

export default CaeAccess;
